import { useEffect } from "react";
import { App } from "antd";
import { setErrorNotifier } from "./client";

/**
 * Publishes the Ant Design message API to the QueryClient default error handlers. It has to render
 * inside the `App` context, so it lives with the theme provider rather than with QueryProvider.
 */
const ErrorNotifierBridge = () => {
  const { message } = App.useApp();

  useEffect(() => {
    setErrorNotifier(text => {
      message.error(text);
    });
    return () => setErrorNotifier(null);
  }, [message]);

  return null;
};

export default ErrorNotifierBridge;
